const percentageColumnConfig = {
        "electricity-usage": "Electricity",
        "gas-usage": "Gas",
        "carbon-emissions": "Total Emissions",
        "kwh-per-hdd": "kWh/HDD",
};

export default percentageColumnConfig